"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _reflux = _interopRequireDefault(require("reflux"));

var _List = require("react-mdl/lib/List");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Switch = _interopRequireDefault(require("react-mdl/lib/Switch"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _UserService = _interopRequireWildcard(require("./services/UserService"));

var _QuizHome = _interopRequireDefault(require("./QuizHome.scss"));

var _QuizOpponents = _interopRequireDefault(require("./QuizOpponents.scss"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _QuizStrings = require("./QuizStrings");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _QuizHomeStyle = require("./styles/QuizHomeStyle");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _QuizTournament = require("./QuizTournament");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CHUNK_SIZE = 20;

var QuizOpponents = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizOpponents, _DataStoreComponent);

  var _super = _createSuper(QuizOpponents);

  function QuizOpponents(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizOpponents);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateTab", function () {
      if (!_this.currentlyUpdating) {
        _this.getGroupedOpponents();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupedOpponents", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var userAuth, user, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage, loadedUser, opponents, allGamesUnfiltered, allGame;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.currentlyUpdating) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this.currentlyUpdating = true;
              _context.next = 5;
              return _this.props.getAuthToken();

            case 5:
              userAuth = _context.sent;
              user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
              playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
              _context.next = 10;
              return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

            case 10:
              groupUsers = _context.sent;
              storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
              _context.next = 14;
              return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

            case 14:
              groupUsersWithImage = _context.sent;

              // set groupUsers application state
              _EquizzerActions["default"].setGroupUsers(groupUsers); // EquizzerActions.setGroupUsers(groupUsersWithImage)


              loadedUser = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER); // filter logged in user from groupUsers list
              // and get list of opponents

              opponents = [];
              groupUsersWithImage.forEach(function (groupUser) {
                if (loadedUser && groupUser && groupUser.id === loadedUser.id) {
                  loadedUser.picture = groupUser.picture;
                  loadedUser.openGamesCount = groupUser.openGamesCount; // set user application state

                  _EquizzerActions["default"].setUser(loadedUser, 'QuizOpponents');

                  _EquizzerActions["default"].setUserPoints(groupUser.points); // return

                } else {
                  opponents.push(groupUser);
                }
              });
              _context.next = 21;
              return _GameService["default"].loadAllGame(userAuth);

            case 21:
              allGamesUnfiltered = _context.sent;
              _context.next = 24;
              return _GameService["default"].loadLastGameWithEachOpponent(loadedUser, allGamesUnfiltered);

            case 24:
              allGame = _context.sent;

              // console.log("initQuiz, all game: ",allGame)
              // get completed game ids
              // const completedGameIds = GameService.getCompletedGameIds(allGame)
              // const expiredGameIds = await GameService.getAllExpiredGames(allGamesUnfiltered)
              // this.setState({
              //   groupedOpponents: UserService.getCategorizedOpponents(opponents, completedGameIds, expiredGameIds),
              // })
              // set opponentslist application state
              _EquizzerActions["default"].setOpponentsList(opponents); // set allgame application state


              _context.next = 28;
              return _EquizzerActions["default"].setAllGame(allGame);

            case 28:
              // set completed game ids application state
              // EquizzerActions.updateCompletedGameIds(completedGameIds)
              // EquizzerActions.updateExpiredGameIds(expiredGameIds)
              _this.currentlyUpdating = false;

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recursive", function () {
      var opponents = _this.getOpponents(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS] || []).filter(function (opponent) {
        return window.ablyConnectivity.state !== 'connected' || !_this.state.showOnlineOnly || _this.isUserOnlineAndVisible(opponent);
      });

      _this.timer = setTimeout(function () {
        if (_this.unmount) return;

        if (_this.state.showOnlineOnly) {
          _this.setState({
            opponentsToRender: opponents
          });
        }

        var hasMore = _this.state.opponentsToRender.length + CHUNK_SIZE < opponents.length;

        if (_this.state.opponentsToRender.length < opponents.length) {
          _this.setState(function (prev, props) {
            return {
              opponentsToRender: opponents.slice(0, prev.opponentsToRender.length + CHUNK_SIZE)
            };
          });
        }

        if (hasMore) {
          _this.recursive();
        } else {
          _this.timer = null;
          console.log('INFO', 'QuizOpponents', 'all lines rendered', opponents.length);
        }
      }, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function () {
      var scrollElement = document.querySelector('#scrollElement');

      if (scrollElement.scrollTop >= scrollElement.scrollHeight - scrollElement.offsetHeight && _this.state.scrollArrow) {
        _this.setState({
          scrollArrow: false
        });
      } else {
        if (!_this.state.scrollArrow) {
          _this.setState({
            scrollArrow: true
          });
        }
      }
    });
    _this.state = {
      scrollHeight: window.innerHeight - 200,
      scrollArrow: false,
      groupedOpponents: {
        available: [],
        unavailable: []
      },
      searchTerm: null,
      showOnlineOnly: false,
      opponentsToRender: []
    };
    _this.pollingInterval = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizOpponents.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_CATEGORIES, _DataStore.DATA_STORE_PATHS.QD_COMPLETED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_EXPIRED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, _DataStore.DATA_STORE_PATHS.QD_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizOpponents.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    _this.showOrHideTimeout = null;
    _this.currentlyUpdating = false;
    _this.unmount = false;
    return _this;
  }

  (0, _createClass2["default"])(QuizOpponents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.recursive();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (this.props.hidden === true && !prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onHideOrUnmount();
        }, 500);
      } else if (!this.props.hidden && prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onShowOrMount();
        }, 500);
      }

      if (prevState.showOnlineOnly !== this.state.showOnlineOnly || !prevState.showOnlineOnly && this.state.showOnlineOnly) {
        console.log('showOnlineOnly updated');

        if (this.timer !== null) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.recursive();
      }
    }
    /*
    componentWillReceiveProps (nextProps) {
      if (nextProps.hidden === true && !this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.onHideOrUnmount()
        }, 500)
      }
      else if (!nextProps.hidden && this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.onShowOrMount()
        }, 500)
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.showOrHideTimeout);
      this.onHideOrUnmount();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizOpponents.prototype), "componentWillUnmount", this).call(this);

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.unmount = true;
    }
  }, {
    key: "onHideOrUnmount",
    value: function onHideOrUnmount() {
      clearInterval(this.pollingInterval);

      _DeviceInfoHelper["default"].removeOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].removeOfflineListener(this.innerForceUpdate);

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.unmount = true;
    }
  }, {
    key: "onShowOrMount",
    value: function onShowOrMount() {
      var _this3 = this;

      /* this.setState({
       groupedOpponents: UserService.getCategorizedOpponents(this.state.opponents, this.state.completedGameIds, this.state.expiredGameIds),
       }) */
      this.getGroupedOpponents();

      if (!_config["default"].disableQuizPolling) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this3.currentlyUpdating) {
                    console.log('wird grade aktualisiert');
                  } else {
                    _this3.getGroupedOpponents();
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })), 30000);
        this.unmount = false;
      }

      _NavigationManager["default"].setCurrentLocation('quiz_opponents');

      _DeviceInfoHelper["default"].addOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].addOfflineListener(this.innerForceUpdate);
    }
  }, {
    key: "getOpponents",
    value: function getOpponents(groupUsers) {
      if (this.props.tournamentMode) {
        var tournamentPhase = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_PHASE);

        if (tournamentPhase && tournamentPhase !== _QuizTournament.TOURNAMENT_PHASES.END) {
          var myTeam = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME);

          return this.sortTournamentOpponents(groupUsers.filter(function (user) {
            return user['team'] !== myTeam;
          }));
        } else {
          return [];
        }
      } else {
        if (_config["default"].sortPlayersByLastName) {
          return groupUsers.sort(function (obj1, obj2) {
            var obj1LastNameArray = obj1 && obj1.nickname ? obj1.nickname.split(' ') : [];
            var obj1LastName = obj1LastNameArray.length > 1 ? obj1LastNameArray[1] : obj1.nickname;
            var obj2LastNameArray = obj2 && obj2.nickname ? obj2.nickname.split(' ') : [];
            var obj2LastName = obj2LastNameArray.length > 1 ? obj2LastNameArray[1] : obj2.nickname;
            if (obj1LastName.toLowerCase() > obj2LastName.toLowerCase()) return 1;
            if (obj1LastName.toLowerCase() < obj2LastName.toLowerCase()) return -1;
            return 0;
          });
        }

        return groupUsers.sort(function (obj1, obj2) {
          if (obj1.nickname.toLowerCase() > obj2.nickname.toLowerCase()) return 1;
          if (obj1.nickname.toLowerCase() < obj2.nickname.toLowerCase()) return -1;
          return 0;
        });
      }
    }
  }, {
    key: "sortTournamentOpponents",
    value: function sortTournamentOpponents(opponents) {
      var playedOpponents = this.state.data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_OPPONENTS_PLAYED] || {};
      var offlineOpponents = [];
      var onlineOpponents = [];

      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES]) {
        var presences = this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES];

        if (presences && opponents) {
          opponents.forEach(function (opponent) {
            presences[opponent.nickname] ? onlineOpponents.push(opponent) : offlineOpponents.push(opponent);
          });
        }
      }

      var sortOpponents = function sortOpponents(opponents) {
        return opponents.sort(function (a, b) {
          if (playedOpponents[a.id] && playedOpponents[b.id] && playedOpponents[a.id] !== playedOpponents[b.id]) {
            return playedOpponents[a.id] - playedOpponents[b.id];
          }

          if (playedOpponents[a.id] && !playedOpponents[b.id]) {
            return -1;
          }

          if (!playedOpponents[a.id] && playedOpponents[b.id]) {
            return 1;
          }

          var concurrentGamesA = a.openGamesCount;
          var concurrentGamesB = b.openGamesCount;

          if (concurrentGamesA > concurrentGamesB) {
            return 1;
          } else if (concurrentGamesA < concurrentGamesB) {
            return -1;
          } else {
            if (a['nickname'] <= b['nickname']) {
              return -1;
            } else {
              return 1;
            }
          }
        });
      };

      if (offlineOpponents.length > 0 || onlineOpponents.length > 0) {
        return sortOpponents(onlineOpponents).concat(sortOpponents(offlineOpponents));
      } else if (opponents) {
        return sortOpponents(opponents);
      }

      return [];
    }
  }, {
    key: "checkIfCanStartRound",
    value: function checkIfCanStartRound(user) {
      if (this.props.tournamentMode) {
        var currentTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

        var maxConcurrentGames = currentTournament.concurrentGamesPerUser;
        var canStart = false;

        if (maxConcurrentGames) {
          canStart = this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].openGamesCount < maxConcurrentGames && user.openGamesCount < maxConcurrentGames && currentTournament.phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES;
        } else {
          canStart = currentTournament.phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES;
        }

        if (!canStart) {
          (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('QD_TOURNAMENT_CANT_START_NEW_GAMES'), (0, _QuizStrings.getString)('PLEASE_NOTE'), false);
        }

        return canStart;
      }

      return true;
    }
  }, {
    key: "startNewGame",
    value: function startNewGame(user) {
      var _this4 = this;

      var mayStart = this.checkIfCanStartRound(user);

      if (!mayStart) {
        return;
      }

      var okButton = {
        label: (0, _QuizStrings.getString)('LETS_GO'),
        callback: function callback() {
          _this4.props.onSetOpponent(user);
        }
      };
      var cancelButton = {
        label: (0, _QuizStrings.getString)('NOT_NOW'),
        callback: function callback() {}
      };
      (0, _AlertHelper.showAlertWithOptions)({
        html: (0, _QuizStrings.getString)('START_NEW_GAME', [user.nickname]),
        title: (0, _QuizStrings.getString)('NEW_GAME'),
        centeredContent: true,
        buttons: [okButton, cancelButton]
      }); // showWideAlertHtml(getString('START_NEW_GAME', [user.nickname]), getString('NEW_GAME'), true, [okButton, cancelButton])
    }
  }, {
    key: "getGameWithOpponent",
    value: function getGameWithOpponent(opponent) {
      return this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME].find(function (game) {
        return game.opponent === opponent.id || game.challenger === opponent.id;
      }) : undefined;
    }
  }, {
    key: "isUserOnlineAndVisible",
    value: function isUserOnlineAndVisible(opponent) {
      // keep the double "!!"
      var presences = this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES];
      return opponent.isRobot || Boolean([opponent.nickname]) && presences && presences[opponent.nickname] && !!presences[opponent.nickname].showOnlineState;
    }
  }, {
    key: "renderFilterButtons",
    value: function renderFilterButtons() {
      var _this5 = this;

      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES]) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizOpponents["default"].filterButtons
        }, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
          checked: this.state.showOnlineOnly,
          className: _QuizOpponents["default"]["switch"],
          onChange: function onChange() {
            _this5.setState({
              showOnlineOnly: !_this5.state.showOnlineOnly
            });
          }
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: _QuizOpponents["default"].filterText
        }, "Nur Online-Spieler"));
      }

      return null;
    }
  }, {
    key: "renderPresence",
    value: function renderPresence(opponent) {
      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES]) {
        var presences = this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES];
        var isPresent = opponent.isRobot || presences && Boolean(presences[opponent.nickname]);
        var isInvisible = !opponent.isRobot && isPresent && !this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES][opponent.nickname].showOnlineState;
        var cssClass;
        var content = '';

        if (window.ablyConnectivity.state !== 'connected') {
          cssClass = _QuizHome["default"].deviceOffline;
        } // else if (isInvisible) {
        //   cssClass = styles.userInvisible
        //   content = '?'
        // }
        else if (isPresent && !isInvisible) {
            cssClass = _QuizHome["default"].userOnline;
          } else {
            cssClass = _QuizHome["default"].userOffline;
          }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: cssClass
        }, content);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var dynamicStyles = (0, _QuizHomeStyle.getStyles)(this.state, this.props);
      var additionalClassName = this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES] ? _QuizHome["default"].innerContentExtraHeight : _QuizHome["default"].innerContentNormalHeight;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        style: (0, _assign["default"])({}, dynamicStyles.outerStyle, {
          maxHeight: '100%'
        })
      }, this.renderFilterButtons(), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_QuizHome["default"].innerContent, " ").concat(additionalClassName)
      }, this.state.opponentsToRender.map(function (opponent) {
        var nicknameToUse = opponent.nickname;

        if (_config["default"].sortPlayersByLastName) {
          var nicknameArray = opponent.nickname.split(' ');
          nicknameToUse = nicknameArray.length > 1 ? "".concat(nicknameArray[1], ", ").concat(nicknameArray[0]) : opponent.nickname;
        }

        var game = _this6.getGameWithOpponent(opponent);

        return /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "opponent_".concat(opponent.id),
          className: _QuizHome["default"].listItem,
          onClick: game ? function () {
            return _this6.props.onShowResults(game, opponent);
          } : function () {
            return _this6.startNewGame(opponent);
          },
          style: dynamicStyles.listItemStyle
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: _QuizHome["default"].opponentsTextFullWidth
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _QuizHome["default"].icon,
          name: game ? game.finished ? 'check-circle' : game.activePlayer === _this6.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && !game.isDirty ? 'play-circle' : 'hourglass-half' : 'play-circle'
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].thumb
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "img",
          src: opponent.picture ? opponent.picture : _UserService.DEFAULT_IMAGE
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanTextWide
        }, _this6.renderPresence(opponent), " ", nicknameToUse)));
      })));
    }
  }]);
  return QuizOpponents;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizOpponents;
QuizOpponents.propTypes = {
  onBack: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  onShowResults: _propTypes["default"].func.isRequired,
  onSetOpponent: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  tournamentMode: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool
};